import PropTypes from 'prop-types';

import { PageCardPropsType } from 'Type/CMS.type';
import { PageInfoType } from 'Type/Order.type';
import { ItemType } from 'Type/ProductList.type';

export const SearchResultFilterItemType = PropTypes.shape({
    label: PropTypes.string,
    count: PropTypes.number,
    value_string: PropTypes.string, // alias of value
    image: PropTypes.string,
    category_url: PropTypes.string
});

export const SearchResultFilterType = PropTypes.shape({
    name: PropTypes.string, // alias of label
    request_var: PropTypes.string, // alias of attribute_code
    // count: PropTypes.number,
    is_boolean: PropTypes.bool,
    position: PropTypes.number,
    filter_items: PropTypes.arrayOf(SearchResultFilterItemType) // alias of options
});

export const SearchResultType = PropTypes.shape({
    __typename: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.oneOfType([
        ItemType,
        PageCardPropsType,
        PropTypes.shape({
            title: PropTypes.string,
            url: PropTypes.string,
            content_type: PropTypes.string,
            id: PropTypes.string,
            faq_category_id: PropTypes.number
        })
    ])),
    page_info: PageInfoType,
    total_count: PropTypes.number,
    filters: PropTypes.arrayOf(SearchResultFilterType), // alias of aggregations,
    type: PropTypes.string
});

export const SearchResultsType = PropTypes.arrayOf(SearchResultType);
